export const GALLERY_VARIANTS = {
  modern: 'modern',
  classic: 'classic',
  compact: 'compact',
} as const;

export type GalleryVariant =
  (typeof GALLERY_VARIANTS)[keyof typeof GALLERY_VARIANTS];

/**
 * - `extraGallery`: Show the extra gallery style selector
 * - `sideStats`: Show the side stats bar
 * - `galleryVariant`: The user's preferred gallery design
 * - `specs`: `LotSpecs` that the user has "pinned"
 */
export const userSettings = {
  extraGallery: false,
  sideStats: false,
  galleryVariant: GALLERY_VARIANTS.modern,
  specs: {},
};
